import { isRenderInQueue } from '@/shared/lib/render-status';
import type { JobQueueStateCreator, ControlsSlice } from './types';

export const createControlsSlice: JobQueueStateCreator<ControlsSlice> = (
  set,
  get
) => ({
  setQueueControls: (controls) => set({ queueControls: controls }),

  addQueueControl: (control) =>
    set((state) => ({
      queueControls: [...state.queueControls, control],
    })),

  updateControlStatus: (controlId, status) =>
    set((state) => ({
      queueControls: state.queueControls.map((c) =>
        c.id === controlId ? { ...c, status } : c
      ),
    })),

  removeQueueControl: (controlId) =>
    set((state) => ({
      queueControls: state.queueControls.filter((c) => c.id !== controlId),
    })),

  getActiveControls: () =>
    get().queueControls.filter((c) => isRenderInQueue(c.status)),

  getControlById: (controlId) =>
    get().queueControls.find((c) => c.id === controlId),

  getControlForAngle: (angleId, controlType) =>
    get().queueControls.find(
      (c) =>
        c.angleId === angleId &&
        (!controlType || c.controlType === controlType) &&
        isRenderInQueue(c.status)
    ),

  getActiveControlCount: () =>
    get().queueControls.filter((c) => isRenderInQueue(c.status)).length,
});
